import BigNumber from 'bignumber.js'
import erc20 from 'config/abi/erc20.json'
import masterchefABI from 'config/abi/masterchef.json'
import multicall from 'utils/multicall'
import { getMasterChefAddress } from 'utils/addressHelpers'
import farmsConfig from 'config/constants/farms'
import { QuoteToken } from '../../config/constants/types'

const CHAIN_ID = process.env.REACT_APP_CHAIN_ID

const fetchFarms = async () => {
  const data = await Promise.all(
    farmsConfig.map(async (farmConfig) => {
      const lpAdress = farmConfig.lpAddresses[CHAIN_ID]
      const calls = [
        // Balance of token in the LP contract
        {
          address: farmConfig.tokenAddresses[CHAIN_ID],
          name: 'balanceOf',
          params: [lpAdress],
        },
        // Balance of quote token on LP contract
        {
          address: farmConfig.quoteTokenAdresses[CHAIN_ID],
          name: 'balanceOf',
          params: [lpAdress],
        },
        // Balance of LP tokens in the master chef contract
        {
          address: farmConfig.isTokenOnly ? farmConfig.tokenAddresses[CHAIN_ID] : lpAdress,
          name: 'balanceOf',
          params: [getMasterChefAddress()],
        },
        // Total supply of LP tokens
        {
          address: lpAdress,
          name: 'totalSupply',
        },
        // Token decimals
        {
          address: farmConfig.tokenAddresses[CHAIN_ID],
          name: 'decimals',
        },
        // Quote token decimals
        {
          address: farmConfig.quoteTokenAdresses[CHAIN_ID],
          name: 'decimals',
        },


      ]

      const [
        tokenBalanceLP,
        quoteTokenBalanceLP,
        lpTokenBalanceMC,
        lpTotalSupply,
        tokenDecimals,
        quoteTokenDecimals
      ] = await multicall(erc20, calls)


      let tokenAmount;
      let lpTotalInQuoteToken;
      let tokenPriceVsQuote;
      let lpTokenPrice;
      if(farmConfig.isTokenOnly){
        tokenAmount = new BigNumber(lpTokenBalanceMC).div(new BigNumber(10).pow(tokenDecimals));

        if(farmConfig.tokenSymbol === QuoteToken.BUSD && farmConfig.quoteTokenSymbol === QuoteToken.BUSD){
          tokenPriceVsQuote = new BigNumber(1);
        }else{
          tokenPriceVsQuote = new BigNumber(quoteTokenBalanceLP).div(new BigNumber(tokenBalanceLP));
        }
        lpTotalInQuoteToken = tokenAmount.times(tokenPriceVsQuote);

        // Get tokenPrice
        lpTokenPrice = tokenPriceVsQuote.times(new BigNumber(10).pow(tokenDecimals)).div(new BigNumber(10).pow(quoteTokenDecimals))
      }
      else {
        // Ratio in % a LP tokens that are in staking, vs the total number in circulation
        const lpTokenRatio = new BigNumber(lpTokenBalanceMC).div(new BigNumber(lpTotalSupply))

        // console.log(`lpTotalSupply: ${lpTotalSupply}`)
        // console.log(`lpTokenBalanceMC: ${lpTokenBalanceMC}`)

        // Total value in staking in quote token value
        lpTotalInQuoteToken = new BigNumber(quoteTokenBalanceLP)
          .div(new BigNumber(10).pow(18))
          .times(new BigNumber(2))
          .times(lpTokenRatio)

        // console.log(`tokenBalanceLP ${tokenBalanceLP}`)
        // Amount of token in the LP that are considered staking (i.e amount of token * lp ratio)
        tokenAmount = new BigNumber(tokenBalanceLP).div(new BigNumber(10).pow(tokenDecimals)).times(lpTokenRatio)
        const quoteTokenAmount = new BigNumber(quoteTokenBalanceLP)
          .div(new BigNumber(10).pow(quoteTokenDecimals))
          .times(lpTokenRatio)
        
        // console.log(`tokenAmount: ${tokenAmount}`)
        // console.log(`qutoeTokenAmount: ${quoteTokenAmount}`)

        if(tokenAmount.comparedTo(0) > 0){
          tokenPriceVsQuote = quoteTokenAmount.div(tokenAmount);
        }else{
          tokenPriceVsQuote = new BigNumber(quoteTokenBalanceLP).div(new BigNumber(tokenBalanceLP)).times(new BigNumber(10).pow(tokenDecimals - quoteTokenDecimals));
        }
        // console.log('lpTotalInQuoteToken',Number(lpTotalInQuoteToken))
        // console.log('tokenPriceVsQuote',Number(tokenPriceVsQuote))

        // Get lpTokenPrice
        const decimalTotal = new BigNumber(tokenDecimals).plus(new BigNumber(quoteTokenDecimals))
        // console.log('tokenDecimals',Number(tokenDecimals))
        // console.log('quoteTokenDecimals',Number(quoteTokenDecimals))

        if (quoteTokenDecimals > 6) {
          lpTokenPrice = lpTotalInQuoteToken.times(new BigNumber(10).pow(tokenDecimals - quoteTokenDecimals)).div(new BigNumber(lpTokenBalanceMC)).times(new BigNumber(10).pow((new BigNumber(decimalTotal)).div(new BigNumber(2))))
        } else {
          lpTokenPrice = lpTotalInQuoteToken.times(new BigNumber(10).pow(18)).div(new BigNumber(lpTokenBalanceMC)).times(new BigNumber(10).pow((new BigNumber(decimalTotal)).div(new BigNumber(2))))
        }
        // console.log("price", Number(lpTokenPrice))
      }


      const [info, totalAllocPoint, BallPerBlock] = await multicall(masterchefABI, [
        {
          address: getMasterChefAddress(),
          name: 'poolInfo',
          params: [farmConfig.pid],
        },
        {
          address: getMasterChefAddress(),
          name: 'totalAllocPoint',
        },
        {
          address: getMasterChefAddress(),
          name: 'polydatePerBlock',
        },
      ])

      const allocPoint = new BigNumber(info.allocPoint._hex)
      const poolWeight = allocPoint.div(new BigNumber(totalAllocPoint))

      return {
        ...farmConfig,
        tokenAmount: tokenAmount.toJSON(),
        // quoteTokenAmount: quoteTokenAmount,
        lpTotalInQuoteToken: lpTotalInQuoteToken.times(new BigNumber(10).pow(tokenDecimals - quoteTokenDecimals)).toJSON(),
        lpTokenPrice: Number(lpTokenPrice),
        tokenPriceVsQuote: tokenPriceVsQuote.toJSON(),
        poolWeight: poolWeight.toNumber(),
        multiplier: `${allocPoint.div(10).toString()}X`,
        depositFeeBP: info.depositFeeBP,
        polydatePerBlock: new BigNumber(BallPerBlock).toNumber(),
        decimals:Number(tokenDecimals)
      }
    }),
  )

  console.log("poinqw",data)
  return data
}

export default fetchFarms